import { render, staticRenderFns } from "./view-chat.vue?vue&type=template&id=44ff9a97"
import script from "./view-chat.vue?vue&type=script&lang=js"
export * from "./view-chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports